module.exports = __webpack_public_path__ + "static/media/ECI88_Info.01cc636b.png";